import { computed, Ref, toValue } from 'vue';
import { OptionSwitchEntryType } from '../types';

export function useOptionSwitch(activeId: Ref<string>, entries: OptionSwitchEntryType[]) {
    function setActiveIndex(value: number) {
        const id = getIdFromIndex(value);
        activeId.value = id ?? '';
    }

    function setActiveId(id: string) {
        const index = getIndexFromId(id);
        activeId.value = index !== undefined ? id : '';
    }

    function getIdFromIndex(index: number) {
        return entries.find((e) => e.index === index)?.id;
    }

    function getIndexFromId(id: string) {
        return entries.find((e) => e.id === id)?.index ?? 0;
    }

    const activeIndex = computed(() => {
        const index = getIndexFromId(toValue(activeId));
        return index ?? 0;
    });

    return {
        activeIndex,
        setActiveIndex,
        setActiveId,
        getIdFromIndex,
        getIndexFromId,
    };
}
